import React from 'react'
import PropTypes from 'prop-types'

// @mui
import { Box, IconButton, Typography } from '@mui/material'

import BackspaceIcon from '@mui/icons-material/Backspace';

// core
import { withLang } from '_core/hocs/withLang'

import { TopicList } from '_core/views/MessagesSplash/TopicList'
import { TopicView } from '_core/views/MessagesSplash/TopicView'
import { useMessengerTopic } from '_core/views/MessagesSplash/util.js'

import './Messenger.css'

const RawMessagerMobile = (props) => {
  const { topics, topicId, selectedMessageId, topicSubject, getLangString: l } = props;
  const { selectedTopic, viewMessageId, selectTopic, clearTopic } = useMessengerTopic(
    topics,
    topicId,
    selectedMessageId,
    topicSubject
  );

  if (selectedTopic == null) {
    return (
      <Box>
        <Typography variant="h6">
          {l('r.soobscheniya')}
        </Typography>
        <div className="sidebar">
          <TopicList topics={topics} onSelect={selectTopic} />
        </div>
      </Box>
    );
  }

  return (
    <Box>
      <div>
          <IconButton classes={{ root: "mobile-topic-view-header-button" }} onClick={clearTopic}>
            <BackspaceIcon />
          </IconButton>
        <div style={{"display": "inline"}}>
          <Typography inline variant="h6" className="conversation-snippet">{selectedTopic.subject}</Typography>
          <Typography inline variant="subtitle1" className="conversation-snippet">{selectedTopic.author}</Typography>
        </div>
      </div>
      <TopicView
        key={`${selectedTopic.id}:${viewMessageId ?? 'last'}`}
        topicId={selectedTopic.id}
        selectedMessageId={viewMessageId}
      />
    </Box>
  );
}

RawMessagerMobile.defaultProps = {}

RawMessagerMobile.propTypes = {
  // self props
  topicId: PropTypes.number,
  selectedMessageId: PropTypes.number,
  topicSubject: PropTypes.string,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const MessagerMobile = withLang(RawMessagerMobile)
